export function wrap<T>(array: T): T extends any[] ? T : T[]
export function wrap(array: any) {
  return Array.isArray(array) ? array : [array]
}

export function unwrap<T>(array: T): T extends any[] ? T[0] : T {
  return Array.isArray(array) ? array[0] : array
}

export type MaybeArray<T> = T | T[]

export function batch<T>(array: T[], n: number) {
  const batches: T[][] = []
  while (array.length > n) {
    batches.push(array.slice(0, n))
    array = array.slice(n)
  }
  if (array.length > 0) {
    batches.push(array)
  }
  return batches
}
